import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-116fc40f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel" }
const _hoisted_2 = { class: "bullets" }
const _hoisted_3 = ["onClick"]

import { ref, toRefs, withDefaults, onMounted } from "vue";
import { ImagePath } from "@/schemas/common";
import { getImage } from "@/utils/images";


export default /*#__PURE__*/_defineComponent({
  __name: 'Carousel',
  props: {
    items: null,
    width: { default: "100%" },
    height: { default: "600px" },
    interval: { default: 6000 },
    background: { default: "#fff" },
    bulletColor: { default: "#fff" },
    bulletHoverColor: { default: "#fff212" }
  },
  setup(__props: any) {

const props = __props as { items: ImagePath[], width: string, height: string, interval: number, background: string, bulletColor: string, bulletHoverColor: string };

_useCssVars(_ctx => ({
  "e56d8ed8": (_unref(height)),
  "35fd7e1b": (_unref(background)),
  "477464b9": (_unref(width)),
  "721a4556": (__props.bulletHoverColor),
  "5632bf98": (__props.bulletColor)
}))



const { items, width, height, background, interval } = toRefs(props);

const loop = ref();
const animate = ref(false);
const selected = ref(0);

const setAnimate = () => {
  animate.value = true;
  setTimeout(() => {
    animate.value = false;
  }, 50);
};

const nex = () => {
  if (items.value.length > 0) {
    if (selected.value < items.value.length - 1) {
      selected.value += 1;
    } else {
      selected.value = 0;
    }
    setAnimate();
  }
};

const previous = () => {
  if (selected.value > 0) {
    selected.value -= 1;
    setAnimate();
  }
};

const carouselImage = () => {
  return getImage(
    items.value[selected.value].path,
    items.value[selected.value].local
  );
};

const style = () => {
  return {
    "background-image": `url(${getImage(
      items.value[selected.value].path,
      items.value[selected.value].local
    )})`,
  };
};

const startLoop = () => {
  loop.value = setInterval(() => {
    nex();
  }, interval.value);
};

const stopLoop = () => {
  clearInterval(loop.value);
};

onMounted(() => {
  startLoop();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ items: true, animate: animate.value }),
      style: _normalizeStyle(style()),
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (stopLoop())),
      onMouseout: _cache[1] || (_cache[1] = ($event: any) => (startLoop()))
    }, null, 38),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass({ bullet: true, active: selected.value === index }),
          onClick: ($event: any) => (selected.value = index)
        }, null, 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})